import { ThemeProvider } from "@repo/ui/components/theme-provider"
import { Route, Routes } from "react-router"

import { AppShell } from "@/components/app-shell"
import { ForgotPasswordPage } from "@/routes/forgot-password"
import { HomePage } from "@/routes/home"
import { LoginPage } from "@/routes/login"
import { NotesPage } from "@/routes/notes"
import { NotFoundPage } from "@/routes/not-found"
import { ProjectsPage } from "@/routes/projects"
import { RemindersPage } from "@/routes/reminders"
import { ResetPasswordPage } from "@/routes/reset-password"
import { SettingsPage } from "@/routes/settings"

export function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="login" element={<LoginPage />} />
        <Route path="forgot-password" element={<ForgotPasswordPage />} />
        <Route path="reset-password" element={<ResetPasswordPage />} />
        <Route element={<AppShell />}>
          <Route index element={<HomePage />} />
          <Route path="reminders" element={<RemindersPage />} />
          <Route path="notes" element={<NotesPage />} />
          <Route path="projects" element={<ProjectsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ThemeProvider>
  )
}
